import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContactsList, getStaticContactList, } from "../../actions/contactListAction";
import { LoadingScreen } from "../../UiComponents/LoadingComponent"
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { useState } from "react";
import { getDateFormatted } from "../../utils/GridFormatter";
import { sbaAxios } from "../../utils/sbaAxios";
import {  insertOrUpdateStaticList,deleteContactListApi, getStaticListContacts } from "../../../config/apiConfig";
import { SBNotify } from "../../utils/sbNotify";
import { useRef } from "react";
import { Modal,Form } from 'react-bootstrap';

export const StaticList = () => {
    const dispatch = useDispatch();
    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;

    const contactList = Gstate.Contacts.contactList;
    const isListLoading = Gstate.Contacts.isContactListLoading;
    const contactListMeta = {
        ContactListId: 0,
        ContactListName: null,
        ContactListDecription: null,
        SelectedMemberList: null,
    };
    const staticContactList = Gstate.Contacts.staticContactList;
    const isStaticLoad = Gstate.Contacts.isStaticContactListLoading;
    const [availableContact, setAvailableContact] = useState(contactList)
    const [drawerState, setDrawerState] = useState(false);
    const [opContactList, setOpContactList] = useState(contactListMeta);
    const [selectedContact, setSelectecContact] = useState([]);
    const [showModal,setShowModal]=useState(false);
    const availableContactApi=useRef();
    const selectedContactApi=useRef();
    const [render,setRender]=useState(false);
    
    useEffect(()=>{
        dispatch(getStaticContactList());
    },[render])
    


    useEffect(() => {
        setAvailableContact(contactList);
    }, [contactList, isListLoading]);
    const ActionRenderer=(props)=>{
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable])
              return (
                <div className="actions-cell">
                  <i className={"fas fa-edit"} style={{ color: isEdit ? "#47A547" :'grey', margin: "0 8px", cursor: "pointer" }} onClick={() => {isEdit && EditList(props)}}></i>
                  <i className={"fa fa-trash"} style={{ color: isEdit ?"#DF001B": 'grey', margin: "0 8px", cursor: "pointer" }} onClick={() => {isEdit && setOpContactList(props.data);setShowModal(true) }} ></i>
                </div>
              )
    }
    const columnDefs = [
        { headerName: "List Name", field: "ContactListName", tooltipField: 'ContactListName', filter: "agTextColumnFilter" },
        { headerName: "List Decription", field: "ContactListDecription" , filter: "agTextColumnFilter"},
        { headerName: "Modified By Name", field: "ModifiedByName" , filter: "agTextColumnFilter"},
        //{ headerName: "Modified By", field: "ModifiedBy" },
        { headerName: "Modified Date", field: "ModifiedDate", valueFormatter: getDateFormatted ,filter: "agTextColumnFilter"},
        { headerName: "Action",maxWidth: 100, field: "", cellRenderer: ActionRenderer ,filter: false }
    ];
    const ContactDefs = [
        { headerName: "Contact Name", field: "ContactName", tooltipField: 'ContactName', minWidth: 100 },
        { headerName: "Email", field: "BusinessEmail", tooltipField: 'BusinessEmail', minWidth: 50 },
    ];
    const getContactList = (e) => {
        const searchTerm = e.target.value;
        dispatch(getContactsList(searchTerm));
    };
    const getContactListName = (e) => {
        const newContactListName = e.target.value;
        setOpContactList({ ...opContactList, ContactListName: newContactListName });
    };
    const getContactListDesc = (e) => {
        const newContactDesc = e.target.value;
        setOpContactList({ ...opContactList, ContactListDecription: newContactDesc });
    };
    const updateContactList = () => {
        if (selectedContact.length !== 0 && opContactList.ContactListName && opContactList.ContactListDecription) {
            let selectedConId = '';
            selectedContact.map((item, index) => {
                if (selectedContact.length === index + 1)
                    selectedConId = `${selectedConId}${item.ContactId}`
                else
                    selectedConId = `${selectedConId}${item.ContactId},`
            });
            const saveData = {
                ContactListId: opContactList.ContactListId,
                ContactListName: opContactList.ContactListName,
                ContactListDecription: opContactList.ContactListDecription,
                SelectedMemberList: selectedConId,
                ModifiedBy: null
            }
            sbaAxios({
                url: `${insertOrUpdateStaticList}`,
                data: saveData,
                method: 'post'
            }).then((response => {
                if(saveData.ContactListId==0)
                SBNotify({ type: "success", Msg: "Contact List has been Added Successfully" });
                else
                SBNotify({ type: "success", Msg: "Contact List has been Updated Successfully" });
                setDrawerState(false);
                setRender(!render);
            })).catch(error => {
                SBNotify({ type: "error", Msg: "Error Saving Contact List" });
                console.log(error)
            })
        }
        else {
            if (!opContactList.ContactListName) {
                SBNotify({ type: "warning", Msg: "Please Enter the Contact List Name" });
            }
            if (!opContactList.ContactListDecription) {
                SBNotify({ type: "warning", Msg: "Please Enter the Contact List Description" });
            }
            else if (selectedContact.length < 1) {
                SBNotify({ type: "warning", Msg: "Please Select any One Contact" });
            }
        }
    };
    const availableContactRowClick = (e) => {
        addContact(e.data);
    };
    const addContact = (row) => {
        if (selectedContact.findIndex(item => item.ContactId === row.ContactId) == -1) {
            setSelectecContact([...selectedContact, row])
        }
    };
    const selectedContactRowClick = (e) => {
        setSelectecContact(selectedContact.filter(item => item.ContactId !== e.data.ContactId));
    };
    const InsertNewList = () => {
        setAvailableContact([]);
        setSelectecContact([]);
        setOpContactList(contactListMeta);
        setDrawerState(true)
    };
    const EditList=(props)=>{
        const contactId=props.data.ContactListId
        setAvailableContact([]);
        setOpContactList(props.data);
        setDrawerState(true);
        sbaAxios({url:`${getStaticListContacts}${contactId}`,method:'get'}).then(response=>{
                setSelectecContact(response)
        }).catch(error=>{
            console.log(error,'error loading contact list ')
        })
    };
    const deleteContactList=()=>{
        sbaAxios({url:`${deleteContactListApi}${opContactList.ContactListId}/0`, method:'post'}).then(response=>{
            if(response==1)
            {
                SBNotify({Msg:'Selected Contact List has been Deleted',type:'success'});
            }
            setRender(!render);
        }).catch(error=>{
            console.log(error,'Error deleting Contact List')
        }
        )
        setShowModal(false);
    };
    const addBtnCLick=()=>{
        const newContact = availableContactApi.current.api.getSelectedRows();
        if(newContact.length>0)
        {
            addContact(newContact[0])
        }
    };
    const removeBtnClick=()=>{
        const contactToRemove = selectedContactApi.current.api.getSelectedRows();
        if(contactToRemove.length>0)
        {
            setSelectecContact(selectedContact.filter(item => item.ContactId !== contactToRemove[0].ContactId))
        }
    }
    const defaultColDef={sortable: true, filter: true , floatingFilter: true, flex: 1,resizable:true};
    return <>
        <div className="d-flex">
            <button className="p-sm-btn ms-auto" disabled={!isEditable} onClick={()=>{isEditable && InsertNewList()}}><i className="fa-plus fa-solid"></i>Add</button>
        </div>
        <div className="ag-theme-alpine" style={{ height: 750 }}>
            {isStaticLoad ? <><LoadingScreen /></> : <><AgGridReact columnDefs={columnDefs} defaultColDef={defaultColDef} rowData={staticContactList} enableBrowserTooltips={true}
                tooltipInteraction={true}></AgGridReact></>}
        </div>
        <SBADrawer
            open={drawerState}
            setOpen={() => { setDrawerState(!drawerState) }}
            close={false}
            title={"Insert / Update Contact List"}
            size={'lg'}>
            <div>
                <label className="fw-medium mt-1">Contact List Name</label>
                <Form.Control type="Text" className="w-50" onChange={getContactListName} value={opContactList.ContactListName}/>
                <label className="fw-medium mt-1">Description </label>
                <Form.Control as="Textarea" rows={2} className="w-50" onKeyUp={getContactListDesc}>
                {opContactList.ContactListDecription}
                </Form.Control>
                <label className="fw-medium mt-1">Contact Search</label>
                <Form.Control type="Text" className="w-50" placeholder="Enter Contact Name" onKeyUp={getContactList}  />
                <div className="d-flex mt-3">
                    <div>
                        <label className="fw-medium ">Available Contacts</label>
                        <div className="ag-theme-alpine" style={{ height: 400, width: 400 }}>
                            {isListLoading ? <><LoadingScreen /></> : <>
                                <AgGridReact  ref={availableContactApi} rowSelection="single" columnDefs={ContactDefs} defaultColDef={defaultColDef} onRowDoubleClicked={availableContactRowClick} enableBrowserTooltips={true} rowData={availableContact} ></AgGridReact></>}
                        </div>
                    </div>

                    <div className='d-flex flex-column justify-content-center px-3'>
                        <button className="p-sm-btn my-2" onClick={addBtnCLick}> <i class="fa-solid fa-arrow-right"></i></button>
                        <button className="p-sm-btn my-2" onClick={removeBtnClick}> <i class="fa-solid fa-arrow-left"></i></button>
                    </div>
                    <div>
                        <label className="fw-medium ">Selected Contacts</label>
                        <div className="ag-theme-alpine" style={{ height: 400, width: 400 }}>
                            <AgGridReact ref={selectedContactApi} rowSelection="single" columnDefs={ContactDefs} defaultColDef={defaultColDef} rowData={selectedContact} onRowDoubleClicked={selectedContactRowClick} enableBrowserTooltips={true} ></AgGridReact>
                        </div>
                    </div>
                </div>
                <div className="d-flex mt-4">
                    <button className="ms-auto s-sm-btn me-2" onClick={() => { setDrawerState(false); setAvailableContact([]); setSelectecContact([]) }}>Cancel</button>
                    <button className="p-sm-btn" onClick={updateContactList}>Save</button>
                </div>
            </div>
        </SBADrawer>
        <Modal show={showModal}  >
      <Modal.Header closeButton onClick={()=>{setShowModal(false)}}>
        <Modal.Title>Do you want to delete the selected Conatct List?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>The selected Contact List will be deleted permanently. Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="s-sm-btn mx-1" onClick={()=>{setShowModal(false)}}>Cancel</button>
        <button className='p-sm-btn mx-1' onClick={deleteContactList} >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
    </>
};
